import { TireFinderModal } from "./tirefindercomponent";

$(function ($) {
    const t = $(".home.tire-finder-section");
    const i = $(".findtire-trigger")[0];
    const n = $(".findtire-trigger")[0];
    new TireFinderModal(t, i, n);
});
